// extracted by mini-css-extract-plugin
export default {"root":"UserCard_root__G5h+I","avatar":"UserCard_avatar__9leFN","title":"UserCard_title__YmqAh"};